import { ICalendarContentDoor, ICalendarProductDoor } from '@/common/interfaces/announcement-bar.interface';
import { IApiCalendarDoorContent } from '@/common/interfaces/api.interface';

export default class AnnouncementBarHelper {
  public static transformContentDoorToContentDoorWithOverline(door: IApiCalendarDoorContent, overline: string): ICalendarContentDoor | ICalendarProductDoor {
    const transformedDoor: ICalendarContentDoor | ICalendarProductDoor = {
      buttonText: door.buttonText ?? ``,
      id: door.id,
      imageLink: door.imageLink,
      link: door.link ?? ``,
      overline,
      text: door.text,
      type: door.type,
    };
    if(door.type === `content`) {
      transformedDoor.title = door.title ?? ``;
    }
    if(door.type === `product`) {
      (transformedDoor as ICalendarProductDoor).products = door.products ?? [];
    }
    return transformedDoor;
  }
}
